import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const postEducation = educationData => {
  return dispatch => {
    dispatch({ type: "POST_EDUCATION_LOADING" });
    api
      .educationPost(educationData)
      .then(resp => {
        if (educationData.educationId) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "AddEducationErrorAlertTitle",
          "Virhe tutkinnon tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_EDUCATION_SUCCEEDED",
  payload: { education: data },
});

const postEditSucceeded = data => ({
  type: "POST_EDUCATION_EDIT_SUCCEEDED",
  payload: { education: data },
});

const operationFail = () => ({
  type: "POST_EDUCATION_FAIL"
});